<div class='input-password-confirm'>
  <form [formGroup]='formGroup'
        class='widget'>
    <div class='input-password mb-2'>
      <div class='label-with-info'>
        <pt-input-label
          [isRequired]='requiredPassword'
          [label]="passwordLabel"
          inputId='password'
          style='display: contents'
        ></pt-input-label>
        <pt-icon
          *ngIf='help'
          [iconType]='iconType'
          [key]='iconKey'
          [ngbTooltip]='passwordHelp'
          container='body'
          placement='top-right'
          tooltipClass='input-confirm-password-help-tooltip'
          triggers='click'
        ></pt-icon>
      </div>

      <div class='input-group input-group-sm h-25px'>
        <input [class.is-invalid]='changedPassword && password.invalid'
               [type]='passwordInputState.inputType'
               autocomplete='new-password'
               class='flex-grow-1 form-control form-control-sm h-25px'
               formControlName='password'
               id='password'>
        <div class='input-group-text p-0 h-25px'>
          <button
            (click)='passwordInputState.toggle()'
            class='btn btn-sm btn-outline-secondary d-flex justify-content-center align-items-center border-0 h-25px' type='button'>
            <pt-icon [key]='passwordInputState.iconType.toString()'></pt-icon>
          </button>
        </div>
      </div>

      <ng-container *ngIf='password?.pending; then passwordLoadingMessage; else passwordOtherMessages'></ng-container>

      <ng-template #passwordLoadingMessage>
        <div class='loading-message'>
          <div class='spinner-border text-secondary float-start spinner-border-sm me-1' role='status'>
            <span class='visually-hidden'>{{ 'MESSAGE.LOADING_DOTS' | translate }}</span>
          </div>
          {{ 'MESSAGE.LOADING' | translate }}
        </div>
      </ng-template>

      <ng-template #passwordOtherMessages>
        <ng-container *ngIf='password?.invalid && (password?.dirty || password?.touched)'>
          <div *ngIf='password?.errors.required' class='error-message'>
            {{ 'MESSAGE.FILL_PASSWORD' | translate }}
          </div>
        </ng-container>
      </ng-template>
    </div>

    <div class="mb-2">
      <div class='label-with-info'>
        <pt-input-label
          [isRequired]='requiredConfirmPassword'
          [label]="confirmPasswordLabel"
          inputId='confirmPassword'
          style='display: contents'
        ></pt-input-label>
        <pt-icon
          *ngIf='help'
          [iconType]='iconType'
          [key]='iconKey'
          [ngbTooltip]='passwordHelp'
          container='body'
          placement='top-right'
          tooltipClass='input-confirm-password-help-tooltip'
          triggers='click'
        ></pt-icon>
      </div>
      <div class='input-group input-group-sm'>
        <input [class.is-invalid]='changedConfirmPassword && confirmPassword.invalid'
               [type]='passwordInputState.inputType'
               autocomplete='off'
               class='flex-grow-1 form-control form-control-sm h-25px'
               formControlName='confirmPassword'
               id='confirmPassword'>
        <div class='input-group-text p-0 h-25px'>
          <button
            (click)='passwordInputState.toggle()'
            class='btn btn-sm btn-outline-secondary d-flex justify-content-center align-items-center border-0 h-25px' type='button'>
            <pt-icon [key]='passwordInputState.iconType.toString()'></pt-icon>
          </button>
        </div>
      </div>

      <ng-container *ngIf='confirmPassword?.pending;
      then confirmPasswordLoadingMessage;
      else confirmPasswordOtherMessages'
      ></ng-container>

      <ng-template #confirmPasswordLoadingMessage>
        <div class='loading-message'>
          <div class='spinner-border text-secondary float-start spinner-border-sm me-1' role='status'>
            <span class='visually-hidden'>{{ 'MESSAGE.LOADING_DOTS' | translate }}</span>
          </div>
          {{ 'MESSAGE.LOADING' | translate }}
        </div>
      </ng-template>

      <ng-template #confirmPasswordOtherMessages>
        <ng-container *ngIf='confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)'>
          <div *ngIf='confirmPassword?.errors.required' class='error-message'>
            {{ 'MESSAGE.FILL_CONFIRM_PASSWORD' | translate }}
          </div>

          <div *ngIf='confirmPassword?.errors.noMatching && !confirmPassword?.errors.required' class='error-message'>
            {{ 'MESSAGE.CONFIRM_PASSWORD_NOT_MATCHING' | translate }}
          </div>
        </ng-container>
      </ng-template>
    </div>
  </form>
</div>

<ng-template #passwordHelp>
  <pt-input-password-help
    [passwordHelpParams]='passwordHelpParams'>
  </pt-input-password-help>
</ng-template>
